module.exports = __webpack_public_path__ + "img/canyon_light_ba_detail_rsh1(1).21161e4c.jpg";